import axios from 'axios';

const apiMiddleware = ({ dispatch }) => (next) => async (action) => {
  if (action.type !== 'api/callBegan') return next(action);

  const { url, method, data, onStart, onSuccess, onError } = action.payload;

  if (onStart) dispatch({ type: onStart });

  try {
    const response = await axios.request({
      baseURL: process.env.REACT_APP_API_URL,
      url,
      method,
      data,
    });
    // General success action
    dispatch({ type: 'api/callSuccess', payload: response.data });
    if (onSuccess) dispatch({ type: onSuccess, payload: response.data });
  } catch (error) {
    // General error action
    dispatch({ type: 'api/callFailed', payload: error.message });
    if (onError) dispatch({ type: onError, payload: error.message });
  }
};

export default apiMiddleware;
